import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
// icons
import {
  Home24,
} from '@carbon/icons-react';

const SettingHeader = ({
  title,
  subtitle,
  size = "md",
  style = {},
}) => {
  const location = useLocation();

  const pathname = window.location.pathname.split('/')
  let client = ''
  if (pathname.length > 1) {  client = pathname[1]}

  return (
    <Container style={style}>

      {/* <Title size={size}><Link to={"/"}><Home24/></Link> {title}</Title> */}
      <Title size={size}>{location.pathname === `/${client}` ? <span>Dashboard</span> : <Link to={`/${client}`}>Dashboard</Link> } / {title}</Title>
      {subtitle ? <Subtitle size={size}>{subtitle}</Subtitle> : <></>}
    </Container>
  );
};

export default SettingHeader;

const getTitleSize = (size) => {
  switch(size) {
    case "sm": return "18px";
    case "md": return "20px";
    case "lg": return "24px";
    default: return "20px";
  }
}

const getSubtitleSize = size => {
  switch(size) {
    case "sm": return "14px";
    case "md": return "14px";
    case "lg": return "14px";
    default: return "14px";
  }
}

const getMarginBottom = size => {
  if(size === "lg") return "18px";
  return "12px";
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

`

const Title = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: ${props => getTitleSize(props.size)};
  color: #514c4c;
  margin-bottom: ${props => getMarginBottom(props.size)};;
`

const Subtitle = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
  font-size: ${props => getSubtitleSize(props.size)};
  color: #514c4c;
  margin-bottom: 24px;
`
